// Import Swiper and its modules
// https://swiperjs.com/swiper-api#styles if you need to change the styles
import Swiper from 'swiper';
import { FreeMode, Autoplay, Navigation, Pagination } from 'swiper/modules';

// import 'swiper/css';

// import 'swiper/css/autoplay';
// import 'swiper/css/free-mode';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

Swiper.use([Navigation, Pagination, FreeMode, Autoplay]);

// Infinite Logo Slider
new Swiper('.infinite-logo-slider', {
  freeMode: {
    enabled: true,
    momentum: false,
  },
  loop: true,
  allowTouchMove: true,
  slidesPerView: 3,
  spaceBetween: 24,
  autoplay: {
    delay: 0,
    disableOnInteraction: true,
  },
  speed: 5500,
  breakpoints: {
    768: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 5,
    },
    1200: {
      slidesPerView: 6,
    },
  },
});

// Image/video slider
document.querySelectorAll('[data-block-slider]').forEach(function (element) {
  const wrapper = element.querySelector('[data-block-slider-track]');
  const slides = Array.from(
    wrapper.querySelectorAll('[data-block-slider-slide]'),
  );
  const shouldLoop = slides.length > 1;

  if (shouldLoop && slides.length < 5) {
    let cloneIndex = 0;

    while (wrapper.children.length < 5) {
      const clone = slides[cloneIndex % slides.length].cloneNode(true);

      clone.setAttribute('aria-hidden', 'true');
      clone
        .querySelectorAll('[id]')
        .forEach((item) => item.removeAttribute('id'));
      wrapper.appendChild(clone);
      cloneIndex += 1;
    }
  }

  new Swiper(element.querySelector('[data-block-slider-swiper]'), {
    grabCursor: true,
    slidesPerView: 1.15,
    spaceBetween: 20,
    watchOverflow: !shouldLoop,
    loop: shouldLoop,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    navigation: {
      nextEl: element.querySelector('[data-slider-next]'),
      prevEl: element.querySelector('[data-slider-prev]'),
    },
  });
});

// News
document.querySelectorAll('.news-swiper').forEach(function (element) {
  new Swiper(element.querySelector('.swiper-container'), {
    grabCursor: true,
    slidesPerView: 1.15,
    spaceBetween: 20,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    pagination: {
      el: element.querySelector('.news-pagination'),
    },
    navigation: {
      nextEl: element.querySelector('.swiper-button-next'),
      prevEl: element.querySelector('.swiper-button-prev'),
    },
  });
});

// Testimonials
document.querySelectorAll('.testimonial-swiper').forEach(function (element) {
  new Swiper(element.querySelector('.swiper-container'), {
    grabCursor: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    pagination: {
      el: '.testimonial-pagination',
    },
    navigation: {
      nextEl: element.querySelector('.swiper-button-next'),
      prevEl: element.querySelector('.swiper-button-prev'),
    },
  });
});

// Team
document.querySelectorAll('.team-swiper').forEach(function (element) {
  new Swiper(element.querySelector('.swiper-container'), {
    grabCursor: true,
    slidesPerView: 1.25,
    spaceBetween: 15,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    pagination: {
      el: element.querySelector('.team-pagination'),
    },
    navigation: {
      nextEl: element.querySelector('.swiper-button-next'),
      prevEl: element.querySelector('.swiper-button-prev'),
    },
  });
});

// USPS
new Swiper('.usps-swiper', {
  grabCursor: true,
  slidesPerView: 1,
  spaceBetween: 15,
  breakpoints: {
    1024: {
      slidesPerView: 4,
      spaceBetween: 22,
    },
  },
});
